import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { from, BehaviorSubject } from "rxjs";
import { Auth } from "aws-amplify";
@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
    isRefreshingToken = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    constructor(
        public injector: Injector
    ) { }
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // convert promise to observable using 'from' operator
        return from(this.handle(req, next))
    }
    async handle(req: HttpRequest<any>, next: HttpHandler) {
        try {
            let currentSession: any = await Auth.currentSession();
            const authReq = req.clone({
                setHeaders: {
                    Authorization: currentSession && currentSession.idToken && currentSession.idToken.jwtToken ? `Bearer ${currentSession.idToken.jwtToken}` : ''
                }
            });
            // Important: Note the .toPromise()
            return next.handle(authReq).toPromise();
        } catch (e) {
            return next.handle(req).toPromise()
        }
    }
}
